import { useMutation, useQueryClient } from 'react-query'
import { OrdersApi } from '@trybeapp/sdk.shop'

const api = new OrdersApi()

export const useAddOrderDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (args) => {
      const [orderId, discount] = args
      return await api.orderDiscountStore(orderId, discount)
    },
    {
      onSuccess: (_, args) => {
        const [orderId] = args
        queryClient.invalidateQueries(['orders', orderId])
        queryClient.invalidateQueries(['orderDiscounts', orderId])
      },
    }
  )
}

export const useDeleteOrderDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (args) => {
      const [orderId, discountId] = args
      return await api.orderDiscountDestroy(orderId, discountId)
    },
    {
      onSuccess: (_, args) => {
        const [orderId] = args
        queryClient.invalidateQueries(['orders', orderId])
        queryClient.invalidateQueries(['orderDiscounts', orderId])
      },
    }
  )
}

export const useAddOrderItemDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (args) => {
      const [orderId, itemId, discount] = args
      return await api.orderItemDiscountStore(orderId, itemId, discount)
    },
    {
      onSuccess: (_, args) => {
        const [orderId] = args
        queryClient.invalidateQueries(['orders', orderId])
      },
    }
  )
}

export const useDeleteOrderItemDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (args) => {
      const [orderId, itemId, discountId] = args
      return await api.orderItemDiscountDestroy(orderId, itemId, discountId)
    },
    {
      onSuccess: (_, args) => {
        const [orderId] = args
        queryClient.invalidateQueries(['orders', orderId])
      },
    }
  )
}
